import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ISPA from '../../assets/images/Industrial partners/ISPA.png'
import MCCIA from '../../assets/images/Industrial partners/MCCIA.png' 
import MSME from '../../assets/images/Industrial partners/MSME.png'
import SIAINDIA from '../../assets/images/Industrial partners/SIAINDIA.png'
import SIDM from '../../assets/images/Industrial partners/SIDM.png'



function IndustrialPartners() {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="mb-50">
      <div className="container">
        <h2 className="text-center py-20">Industrial Associations</h2>
        <Slider {...settings}>
          <div className="slide-item px-1 ">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="ind-partner" src={ISPA} alt="ISA Logo"  />
              </div>
            </div>
          </div>

          <div className="slide-item px-1 ">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon ">
                <img className="ind-partner" src={MCCIA} alt="MCCIA Logo" height="140px" width="140px" />
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div >
                <img className="ind-partner mt-2" src={MSME} alt="MSME Logo" />
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="ind-partner" src={SIAINDIA} alt="SIAINDIA Logo"  />
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="ind-partner" src={SIDM} alt="SIDM Logo"  />
              </div>
            </div>
          </div>

          

        </Slider>
      </div>


    </section>
  );
}

export default IndustrialPartners;
